import { Star, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TESTIMONIALS } from "../../lib/data";

// Testimonials always render 3-in-a-row — including phones — per approved
// design. On narrow widths content compacts: shorter excerpt via CSS clamp,
// smaller stars, tighter padding. Underlying testimonial data is untouched.
export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="px-3 sm:px-4 pt-6 sm:pt-10">
      <div className="mx-auto max-w-6xl">
        <SectionHeading testId="testimonials-heading">What Our Clients Say</SectionHeading>

        <div className="grid grid-cols-3 gap-2 sm:gap-4 lg:gap-5 mt-5 sm:mt-7">
          {TESTIMONIALS.slice(0, 3).map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <div
                className="vb-card h-full p-2 sm:p-4 lg:p-6 flex flex-col"
                data-testid={`testimonial-${i}`}
                style={{ minWidth: 0 }}
              >
                <div className="flex justify-center gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star
                      key={s}
                      className="text-[#d6d400]"
                      fill="#d6d400"
                      style={{ width: "clamp(9px, 1.1vw, 15px)", height: "clamp(9px, 1.1vw, 15px)" }}
                    />
                  ))}
                </div>
                <p
                  className="font-body text-[#c9c9ba] italic text-center leading-snug flex-1"
                  style={{
                    fontSize: "clamp(12px, 1vw, 15px)",
                    display: "-webkit-box",
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  “{t.quote}”
                </p>
                <div className="flex items-end justify-between mt-2 sm:mt-4 gap-1">
                  <div className="min-w-0">
                    <div
                      className="font-display font-bold text-[#f4f4ea] tracking-wide truncate"
                      style={{ fontSize: "clamp(9.5px, 1vw, 14px)" }}
                    >
                      — {t.name}
                    </div>
                    <div
                      className="font-body text-[#8f9080] uppercase tracking-[0.1em] truncate"
                      style={{ fontSize: "clamp(8px, 0.85vw, 11px)" }}
                    >
                      {t.role}
                    </div>
                  </div>
                  <Quote
                    className="text-[#d6d40044] shrink-0"
                    fill="currentColor"
                    style={{ width: "clamp(14px, 1.8vw, 26px)", height: "clamp(14px, 1.8vw, 26px)" }}
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
